<p-dialog
    header="Integration URL"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [style]="{ width: '42rem' }"
    appendTo="body"
>
    <div class="flex flex-col gap-4">
        <p class="text-sm text-color-secondary">
            Paste this URL as a web connection in your favorite reporting tool to access this report's data.
            Keep it private — it contains your personal API key.
        </p>

        <textarea
            pTextarea
            [value]="url()"
            readonly
            rows="6"
            class="w-full font-mono text-sm"
        ></textarea>
    </div>

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button severity="secondary" label="Close" (onClick)="close()" />
            <p-button
                [label]="copied() ? 'Copied!' : 'Copy'"
                [icon]="copied() ? 'pi pi-check' : 'pi pi-copy'"
                (onClick)="copyUrl()"
            />
        </div>
    </ng-template>
</p-dialog>
